import { StyledContainer } from "@components/Styled/Container";
import React from "react";
import ReactPaginate, { type ReactPaginateProps } from "react-paginate";

import { clsx } from "clsx";

import { IconChevronRight, IconChevronLeft } from "@bared/ui";

type PaginationProps = ReactPaginateProps & {
  loading?: boolean;
};

const Container = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, "relative flex flex-col items-end")}
  />
);

const Wrapper = (props: any) => (
  <ReactPaginate {...props} className={clsx(props.className, "flex")} />
);

const ShowEmpty = (props: any) => (
  <p
    {...props}
    className={clsx(props.className, "-bottom-3 right-4 absolute italic")}
  />
);

const Pagination = ({
  pageCount,
  pageRangeDisplayed,
  marginPagesDisplayed,
  onPageChange,
  loading,
}: PaginationProps) => {
  return (
    <Container width="full">
      <Wrapper
        breakClassName="pagination-break"
        breakLabel="..."
        nextClassName="pagination-nav"
        nextLabel={<IconChevronRight className="w-[12px]" />}
        previousClassName="pagination-nav"
        previousLabel={<IconChevronLeft className="w-[12px]" />}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={pageCount}
        marginPagesDisplayed={marginPagesDisplayed}
        renderOnZeroPageCount={null}
        pageClassName="pagination-item"
        onPageChange={onPageChange}
      />
      {loading && <ShowEmpty>Loading...</ShowEmpty>}
    </Container>
  );
};

export default Pagination;
